// see http://vuejs-templates.github.io/webpack for documentation.
var path = require('path');
var db = require('./db');

var urls = {
  host: "http://localhost",
  port: "8080",
  relay: "http://10.1.1.142/api/host/modules"
}

module.exports = {
  build: {
    env: require('./prod.env'),
    index: path.resolve(__dirname, '../dist/index.html'),
    assetsRoot: path.resolve(__dirname, '../dist'),
    assetsSubDirectory: 'static',
    assetsPublicPath: '/',
    productionSourceMap: true,

    productionGzip: true,
    productionGzipExtensions: ['js', 'css'],

    bundleAnalyzerReport: process.env.npm_config_report
  },
  dev: {
    env: require('./dev.env'),
    host: urls['host'],
    port: urls['port'],
    autoOpenBrowser: false,
    assetsSubDirectory: 'static',
    assetsPublicPath: '/',
    proxyTable: {},
    cssSourceMap: false
  },
  roles: {
    superadmin: 3,
    admin: 2,
    booking: 1,
    general: 0
  },
  host: urls['host'],
  port: urls['port'],
  relay: urls['relay'],
  session: {
    secret: "Uj5Jq0fV8rtRHag7089F3HKXcmz9r3Si"
  },
  db: {
    username: db.username,
    password: db.password,
    database: "sporte"
  },
  user: {
    deleted: 1,
    roles: {
      superadmin: 3,
      admin: 2,
      booking: 1,
      general: 0
    }
  },
  flags: {
    deleted: 1
  },
  devices: {
    standard: 1,
    switch: 2
  },
  logs: {
    logLevel: "info"
  }

}



//////////////////
// WEBPACK FOOTER
// ./config/index.js
// module id = 317
// module chunks = 23